import { render, staticRenderFns } from "./MyCampaignPayment.vue?vue&type=template&id=64628b42&scoped=true&"
import script from "./MyCampaignPayment.vue?vue&type=script&lang=js&"
export * from "./MyCampaignPayment.vue?vue&type=script&lang=js&"
import style0 from "./MyCampaignPayment.vue?vue&type=style&index=0&id=64628b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64628b42",
  null
  
)

export default component.exports